import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isLogin: false,
    showLoginname: false,
    userInfo: {}, // 用户信息
    userName: '',
    searchKeyName: '',
    isSearched: false,
    isRoot: false, // 用于返回按钮，是否返回到了根页面
    commentTotal: 0, // 评论条数
    hotNums: 0, // 在线总人数
    platformInfo: {}, // 平台信息
    wxConfig: {}, // 微信配置信息
    qrCodeSize: 450, // 二维码像素大小
    qrCodeMargin: 40, // 二维码外间距大小
    qrLogoScale: 50, // 二维码logo大小
    cacheList: [],
    statisticsUrl: '' // 发送统计报文的统计平台ip或域名
  },
  getters: {
    isLogin (state) {
      if (!state.isLogin) {
        state.isLogin = sessionStorage.getItem('isLogin'); // 从sessionStorage中读取状态
      }
      return state.isLogin;
    }
  },
  mutations: {
    isLogins (state, isLogin) {
      state.isLogin = isLogin;
    },
    isRoot (state, isRoot) {
      state.isRoot = isRoot;
    },
    showLogin (state, showLoginname) {
      state.showLoginname = showLoginname;
    },
    setSearhKey (state, searchKeyName) {
      state.searchKeyName = searchKeyName;
    },
    setSearhed (state, isSearched) {
      state.isSearched = isSearched;
    },
    setCommentTotal (state, commentTotal) {
      state.commentTotal = commentTotal;
    },
    setHotNums (state, hotNums) {
      state.hotNums = hotNums;
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    },
    setUserName (state, userName) {
      state.userName = userName;
    },
    setWxConfig (state, wxConfig) {
      state.wxConfig = wxConfig;
    },
    setPlatformInfo (state, platformInfo) {
      state.platformInfo = platformInfo;
    },
    setCacheList (state, msg) {
      if (msg === 'kong') {
        state.cacheList = ['homePage'];
      } else {
        if (!state.cacheList.includes(msg)) {
          state.cacheList.push(msg);
        }
      }
    },
    setStatisticsUrl (state, statisticsUrl) {
      state.statisticsUrl = statisticsUrl;
    }
  },
  actions: {
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js